

// // // import React, { useState, useEffect } from "react";
// // // import axios from 'axios';
// // // import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
// // // import { FaTimes } from 'react-icons/fa';

// // // const Timings = () => {
// // //   const [vendorId, setVendorId] = useState(null);
// // //   const [timings, setTimings] = useState([]);
// // //   const [showAddModal, setShowAddModal] = useState(false);
// // //   const [newTiming, setNewTiming] = useState({
// // //     day: '',
// // //     open: '',
// // //     close: '',
// // //   });

// // //   // Define the correct order of days
// // //   const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// // //   // Function to format time to AM/PM format
// // //   const formatTimeToAMPM = (timeString) => {
// // //     if (!timeString || timeString === '-' || timeString === '') return '-';

// // //     // Remove seconds if present (e.g., "14:30:00" -> "14:30")
// // //     const time = timeString.split(':').slice(0, 2).join(':');

// // //     // Check if time is already in 12-hour format (contains AM/PM)
// // //     if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
// // //       return timeString;
// // //     }

// // //     // Convert to AM/PM format
// // //     const [hours, minutes] = time.split(':');
// // //     if (!hours || !minutes) return '-';

// // //     const hour = parseInt(hours, 10);
// // //     if (isNaN(hour)) return '-';

// // //     const ampm = hour >= 12 ? 'PM' : 'AM';
// // //     const hour12 = hour % 12 || 12;

// // //     return `${hour12}:${minutes} ${ampm}`;
// // //   };

// // //   useEffect(() => {
// // //     const storedVendorId = localStorage.getItem("vendorId");
// // //     if (storedVendorId) {
// // //       setVendorId(storedVendorId);
// // //     }
// // //   }, []);

// // //   const getTableHeight = () => {
// // //     const width = window.innerWidth;

// // //     if (width <= 600) return "400px";
// // //     if (width >= 1000 && width <= 1300) return "400px";
// // //     if (width > 1300) return "500px";

// // //     return "auto";
// // //   };

// // //   // Sort timings by day order
// // //   const sortTimingsByDay = (timingsArray) => {
// // //     return [...timingsArray].sort((a, b) => {
// // //       return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
// // //     });
// // //   };

// // //   useEffect(() => {
// // //     const storedVendorId = localStorage.getItem("vendorId");
// // //     const token = localStorage.getItem("authToken");

// // //     if (!storedVendorId || !token) {
// // //       alert("Missing vendor ID or authentication token. Please log in again.");
// // //       return;
// // //     }

// // //     const fetchTimings = () => {
// // //       axios
// // //         .get(
// // //           `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
// // //           {
// // //             headers: {
// // //               Authorization: `Bearer ${token}`,
// // //             },
// // //           }
// // //         )
// // //         .then((response) => {
// // //           const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

// // //           const mappedTimings = apiTimings.map((item) => ({
// // //             id: item.id,
// // //             day: item.day,
// // //             open: item.startTime ? item.startTime.substring(0, 5) : '',
// // //             close: item.lastTime ? item.lastTime.substring(0, 5) : '',
// // //             checked: item.restaurantStatus === 'Open',
// // //             restaurantStatus: item.restaurantStatus,
// // //             isEditing: false,
// // //           }));

// // //           // Sort timings after mapping
// // //           const sortedTimings = sortTimingsByDay(mappedTimings);
// // //           setTimings(sortedTimings);
// // //         })
// // //         .catch((err) => {
// // //           console.error('Failed to fetch timings', err);
// // //           setTimings([]);
// // //         });
// // //     };

// // //     fetchTimings();
// // //     const intervalId = setInterval(fetchTimings, 10000);

// // //     return () => clearInterval(intervalId);
// // //   }, []);

// // //   const handleAddTiming = () => {
// // //     const vendorId = localStorage.getItem("vendorId");
// // //     const token = localStorage.getItem("authToken");

// // //     if (!vendorId) {
// // //       alert("Vendor ID missing. Please refresh or login again.");
// // //       return;
// // //     }

// // //     if (!token) {
// // //       alert("Authentication token missing. Please log in again.");
// // //       return;
// // //     }

// // //     if (!newTiming.day || !newTiming.open || !newTiming.close) {
// // //       alert("Please fill all fields.");
// // //       return;
// // //     }

// // //     // Check if maximum 7 days reached
// // //     if (timings.length >= 7) {
// // //       alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
// // //       return;
// // //     }

// // //     // Check if day already exists (case-insensitive)
// // //     const dayExists = timings.some(timing =>
// // //       timing.day.toLowerCase() === newTiming.day.toLowerCase()
// // //     );

// // //     if (dayExists) {
// // //       alert(`Timing for ${newTiming.day} already exists!`);
// // //       return;
// // //     }

// // //     const payload = {
// // //       day: newTiming.day,
// // //       startTime: newTiming.open + ":00",
// // //       lastTime: newTiming.close + ":00",
// // //     };

// // //     //console.log("Sending payload:", payload);

// // //     axios
// // //       .post(
// // //         `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
// // //         payload,
// // //         {
// // //           headers: {
// // //             "Content-Type": "application/json",
// // //             Authorization: `Bearer ${token}`,
// // //           },
// // //         }
// // //       )
// // //       .then((res) => {
// // //         //console.log("Success:", res.data);

// // //         // Create new timing object
// // //         const addedTiming = {
// // //           id: res.data.id || Date.now(), // Use response ID or temporary ID
// // //           day: res.data.day || newTiming.day,
// // //           open: newTiming.open,
// // //           close: newTiming.close,
// // //           checked: false,
// // //           restaurantStatus: 'Open',
// // //           isEditing: false,
// // //         };

// // //         // Add to timings and sort
// // //         const updatedTimings = sortTimingsByDay([...timings, addedTiming]);
// // //         setTimings(updatedTimings);

// // //         alert("Timing added successfully!");
// // //         setShowAddModal(false);
// // //         setNewTiming({ day: '', open: '', close: '' });
// // //       })
// // //       .catch((err) => {
// // //         console.error("Failed to add timing:", err);
// // //         if (err.response) {
// // //           console.error("Status:", err.response.status);
// // //           console.error("Data:", JSON.stringify(err.response.data, null, 2));
// // //           alert("Error adding timing: " + JSON.stringify(err.response.data));
// // //         } else {
// // //           alert("Network error or server not reachable.");
// // //         }
// // //       });
// // //   };

// // //   const handleDeleteTiming = (id) => {
// // //     const token = localStorage.getItem("authToken");

// // //     if (!token) {
// // //       alert("Authentication token missing. Please log in again.");
// // //       return;
// // //     }

// // //     if (!window.confirm('Are you sure you want to delete this timing?')) return;

// // //     //console.log('Deleting timing with id:', id);

// // //     axios
// // //       .delete(
// // //         `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
// // //         {
// // //           headers: {
// // //             Authorization: `Bearer ${token}`,
// // //           },
// // //         }
// // //       )
// // //       .then((res) => {
// // //         //console.log('Deleted timing:', res.data);
// // //         setTimings((prev) => prev.filter((timing) => timing.id !== id));
// // //       })
// // //       .catch((err) => {
// // //         console.error('Failed to delete timing:', err.response?.data || err.message);
// // //         alert('Failed to delete timing. Please try again.');
// // //       });
// // //   };

// // //   const toggleEdit = (index) => {
// // //     const timing = timings[index];
// // //     const token = localStorage.getItem("authToken");

// // //     if (!token) {
// // //       alert("Authentication token missing. Please log in again.");
// // //       return;
// // //     }

// // //     if (timing.isEditing) {
// // //       // Only update time fields, not day
// // //       const updatedData = {
// // //         id: timing.id,
// // //         day: timing.day, // Keep the original day
// // //         startTime: timing.open + ":00",
// // //         lastTime: timing.close + ":00",
// // //       };

// // //       //console.log("➡️ Sending PUT to edit timing (only time fields):", updatedData);

// // //       axios
// // //         .put(
// // //           `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
// // //           updatedData,
// // //           {
// // //             headers: {
// // //               "Content-Type": "application/json",
// // //               Authorization: `Bearer ${token}`,
// // //             },
// // //           }
// // //         )
// // //         .then((res) => {
// // //           const updatedTiming = res.data;

// // //           // Update the timing in state (only time fields)
// // //           setTimings(prev => {
// // //             const updated = [...prev];
// // //             updated[index] = {
// // //               ...updated[index],
// // //               // Keep the same day
// // //               open: updatedTiming.startTime ? updatedTiming.startTime.substring(0, 5) : timing.open,
// // //               close: updatedTiming.lastTime ? updatedTiming.lastTime.substring(0, 5) : timing.close,
// // //               isEditing: false,
// // //             };
// // //             return updated; // No need to re-sort since day doesn't change
// // //           });

// // //           alert("✅ Timing updated successfully!");
// // //         })
// // //         .catch((err) => {
// // //           console.error("❌ Failed to update timing", err);
// // //           console.error("🧾 Response:", err.response?.data);
// // //           alert("Failed to save timing. Please try again.");
// // //         });
// // //     } else {
// // //       setTimings(prev => {
// // //         const updated = [...prev];
// // //         updated[index].isEditing = true;
// // //         return updated;
// // //       });
// // //     }
// // //   };

// // //   const handleSubmit = e => {
// // //     e.preventDefault();
// // //     const savedData = timings.map(({ day, open, close }) => ({ day, open, close }));
// // //     //console.log('Saved Timings:', savedData);
// // //   };

// // //   const handleChange = (index, field, value) => {
// // //     setTimings(prev => {
// // //       const updated = [...prev];
// // //       updated[index][field] = value;
// // //       return updated;
// // //     });
// // //   };

// // //   const handleNewTimingChange = (field, value) => {
// // //     setNewTiming(prev => ({ ...prev, [field]: value }));
// // //   };

// // //   // Get available days (days that haven't been added yet)
// // //   const getAvailableDays = () => {
// // //     const existingDays = timings.map(timing => timing.day);
// // //     return dayOrder.filter(day =>
// // //       !existingDays.some(existingDay =>
// // //         existingDay.toLowerCase() === day.toLowerCase()
// // //       )
// // //     );
// // //   };

// // //   // Disable add button if all 7 days are added
// // //   const isAddButtonDisabled = timings.length >= 7;

// // //   // Set default day when modal opens
// // //   const handleOpenAddModal = () => {
// // //     const availableDays = getAvailableDays();
// // //     setNewTiming({
// // //       day: availableDays[0] || '',
// // //       open: '',
// // //       close: '',
// // //     });
// // //     setShowAddModal(true);
// // //   };

// // //   return (
// // //     <div style={{ padding: "0px", marginTop: "10px" }}>
// // //       <style>{`
// // //       `}

// // //       </style>
// // //       <form onSubmit={handleSubmit}>
// // //         {/* Hide the Add button when all 7 days are added */}
// // //         <button
// // //           onClick={handleOpenAddModal}
// // //           style={{
// // //             marginBottom: '15px',
// // //             padding: '8px 15px',
// // //             fontSize: window.innerWidth <= 1300 ? '13px' : '16px',
// // //             cursor: timings.length < 7 ? 'pointer' : 'not-allowed',
// // //             backgroundColor: timings.length < 7 ? 'rgb(177 92 214)' : 'transparent',
// // //             color: timings.length < 7 ? 'white' : 'transparent',
// // //             border: timings.length < 7 ? 'none' : '1px solid transparent',
// // //             borderRadius: '4px',
// // //             fontWeight: 'bold',
// // //             opacity: timings.length < 7 ? 1 : 0,
// // //             visibility: timings.length < 7 ? 'visible' : 'hidden',
// // //           }}
// // //           disabled={timings.length >= 7}
// // //           title={timings.length >= 7 ? "All 7 days already added" : "Add new timing"}
// // //         >
// // //           Add +
// // //         </button>

// // //         {showAddModal && (
// // //           <div
// // //             style={{
// // //               position: 'fixed',
// // //               top: 0, left: 0, right: 0, bottom: 0,
// // //               backgroundColor: 'rgba(0,0,0,0.5)',
// // //               display: 'flex',
// // //               alignItems: 'center',
// // //               justifyContent: 'center',
// // //               zIndex: 1000,
// // //             }}
// // //           >
// // //             <div
// // //               style={{
// // //                 backgroundColor: 'white',
// // //                 padding: '24px',
// // //                 borderRadius: '10px',
// // //                 width: '360px',
// // //                 boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
// // //                 position: 'relative',
// // //                 fontFamily: 'Arial, sans-serif',
// // //               }}
// // //             >
// // //               <button
// // //                 onClick={() => setShowAddModal(false)}
// // //                 style={{
// // //                   position: 'absolute',
// // //                   top: '10px',
// // //                   right: '10px',
// // //                   color: '#000',
// // //                   border: 'none',
// // //                   borderRadius: '50%',
// // //                   width: '30px',
// // //                   height: '30px',
// // //                   fontSize: '16px',
// // //                   cursor: 'pointer',
// // //                   display: 'flex',
// // //                   alignItems: 'center',
// // //                   justifyContent: 'center',
// // //                 }}
// // //                 aria-label="Close modal"
// // //               >
// // //                 <FaTimes />
// // //               </button>

// // //               <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>

// // //               <div style={{ marginBottom: '15px' }}>
// // //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
// // //                 <select
// // //                   value={newTiming.day}
// // //                   onChange={e => handleNewTimingChange('day', e.target.value)}
// // //                   style={{
// // //                     width: '100%',
// // //                     padding: '8px',
// // //                     border: '1px solid #ccc',
// // //                     borderRadius: '5px',
// // //                     fontSize: '14px',
// // //                   }}
// // //                 >
// // //                   {getAvailableDays().map(day => (
// // //                     <option key={day} value={day}>{day}</option>
// // //                   ))}
// // //                 </select>
// // //                 {getAvailableDays().length === 0 && (
// // //                   <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
// // //                     All days have been added!
// // //                   </div>
// // //                 )}
// // //               </div>

// // //               <div style={{ marginBottom: '15px' }}>
// // //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
// // //                 <input
// // //                   type="time"
// // //                   value={newTiming.open}
// // //                   onChange={e => handleNewTimingChange('open', e.target.value)}
// // //                   style={{
// // //                     width: '100%',
// // //                     padding: '8px',
// // //                     border: '1px solid #ccc',
// // //                     borderRadius: '5px',
// // //                     fontSize: '14px',
// // //                   }}
// // //                   required
// // //                 />
// // //                 {newTiming.open && (
// // //                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
// // //                     Selected: {formatTimeToAMPM(newTiming.open)}
// // //                   </div>
// // //                 )}
// // //               </div>

// // //               <div style={{ marginBottom: '20px' }}>
// // //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
// // //                 <input
// // //                   type="time"
// // //                   value={newTiming.close}
// // //                   onChange={e => handleNewTimingChange('close', e.target.value)}
// // //                   style={{
// // //                     width: '100%',
// // //                     padding: '8px',
// // //                     border: '1px solid #ccc',
// // //                     borderRadius: '5px',
// // //                     fontSize: '14px',
// // //                   }}
// // //                   required
// // //                 />
// // //                 {newTiming.close && (
// // //                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
// // //                     Selected: {formatTimeToAMPM(newTiming.close)}
// // //                   </div>
// // //                 )}
// // //               </div>

// // //               <div style={{ textAlign: 'center' }}>
// // //                 <button
// // //                   onClick={handleAddTiming}
// // //                   disabled={getAvailableDays().length === 0 || !newTiming.open || !newTiming.close}
// // //                   style={{
// // //                     padding: '10px 20px',
// // //                     cursor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 'not-allowed' : 'pointer',
// // //                     backgroundColor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? '#cccccc' : 'rgb(177, 92, 214)',
// // //                     color: 'white',
// // //                     border: 'none',
// // //                     borderRadius: '5px',
// // //                     fontSize: '15px',
// // //                     opacity: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 0.6 : 1,
// // //                   }}
// // //                 >
// // //                   Save
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         )}

// // //         <div style={{ height: getTableHeight(), overflowY: "auto" }}>
// // //           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
// // //             <thead>
// // //               <tr>
// // //                 <th style={tableHeaderStyle}>S.No</th>
// // //                 <th style={tableHeaderStyle}>Day</th>
// // //                 <th style={tableHeaderStyle}>Open Time</th>
// // //                 <th style={tableHeaderStyle}>Close Time</th>
// // //                 <th style={tableHeaderStyle}>Action</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {timings.map((item, index) => (
// // //                 <tr key={item.id || item.day}>
// // //                   <td style={tableCellStyle}>{index + 1}</td>
// // //                   <td style={tableCellStyle}>
// // //                     {/* Day is NOT editable - always show as text */}
// // //                     {item.day}
// // //                   </td>
// // //                   <td style={tableCellStyle}>
// // //                     {item.isEditing ? (
// // //                       <input
// // //                         type="time"
// // //                         value={item.open}
// // //                         onChange={e => handleChange(index, 'open', e.target.value)}
// // //                         style={{ ...inputStyle, }}
// // //                       />
// // //                     ) : (
// // //                       formatTimeToAMPM(item.open)
// // //                     )}
// // //                   </td>
// // //                   <td style={tableCellStyle}>
// // //                     {item.isEditing ? (
// // //                       <input
// // //                         type="time"
// // //                         value={item.close}
// // //                         onChange={e => handleChange(index, 'close', e.target.value)}
// // //                         style={inputStyle}
// // //                       />
// // //                     ) : (
// // //                       formatTimeToAMPM(item.close)
// // //                     )}
// // //                   </td>
// // //                   <td style={tableCellStyle}>
// // //                     <button
// // //                       type="button"
// // //                       onClick={() => toggleEdit(index)}
// // //                       style={{
// // //                         ...buttonStyle,
// // //                         background: 'none',
// // //                         border: 'none',
// // //                         cursor: 'pointer',
// // //                         fontSize: '18px',
// // //                         color: '#4A148C',
// // //                         marginRight: '8px',
// // //                       }}
// // //                     >
// // //                       {item.isEditing ? <FaSave /> : <FaEdit />}
// // //                     </button>
// // //                     <button
// // //                       type="button"
// // //                       onClick={() => handleDeleteTiming(item.id)}
// // //                       style={{
// // //                         ...buttonStyle,
// // //                         background: 'none',
// // //                         border: 'none',
// // //                         cursor: 'pointer',
// // //                         fontSize: '18px',
// // //                         color: 'red',
// // //                       }}
// // //                       title="Delete Timing"
// // //                     >
// // //                       <FaTrash />
// // //                     </button>
// // //                   </td>
// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //         </div>
// // //       </form>
// // //     </div>
// // //   );
// // // };

// // // const tableHeaderStyle = {
// // //   border: '1px solid #ddd',
// // //   textAlign: 'center',
// // //   fontWeight: 'bold',
// // //   backgroundColor: '#b15cd6',
// // //   color: 'white',
// // //   padding:"8px",
// // //   whiteSpace: "nowrap",
// // // };

// // // const tableCellStyle = {
// // //   border: '1px solid #ddd',
// // //   textAlign: 'center',
// // // };

// // // const inputStyle = {
// // //   width: '100%',
// // //   border: 'none',
// // //   backgroundColor: 'transparent',
// // //   textAlign: 'center',
// // // };

// // // const buttonStyle = {
// // //   backgroundColor: '#dc3545',
// // //   color: 'white',
// // //   border: 'none',
// // //   borderRadius: '4px',
// // //   cursor: 'pointer',
// // //   marginRight: "5px"
// // // };

// // // export default Timings;







// // import React, { useState, useEffect } from "react";
// // import axios from 'axios';
// // import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
// // import { FaTimes } from 'react-icons/fa';
// // import { Switch } from "@mui/material";

// // const Timings = () => {
// //   const [vendorId, setVendorId] = useState(null);
// //   const [timings, setTimings] = useState([]);
// //   const [showAddModal, setShowAddModal] = useState(false);
// //   const [newTiming, setNewTiming] = useState({
// //     day: '',
// //     open: '',
// //     close: '',
// //   });
// //   const [isOnline, setIsOnline] = useState(false);

// //   // ✅ Get saved online/offline status
// //   useEffect(() => {
// //     const savedStatus = localStorage.getItem("isOnline");
// //     if (savedStatus !== null) {
// //       setIsOnline(savedStatus === "true");
// //     }
// //   }, []);

// //   // Define the correct order of days
// //   const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// //   // Function to format time to AM/PM format
// //   const formatTimeToAMPM = (timeString) => {
// //     if (!timeString || timeString === '-' || timeString === '') return '-';

// //     // Remove seconds if present (e.g., "14:30:00" -> "14:30")
// //     const time = timeString.split(':').slice(0, 2).join(':');

// //     // Check if time is already in 12-hour format (contains AM/PM)
// //     if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
// //       return timeString;
// //     }

// //     // Convert to AM/PM format
// //     const [hours, minutes] = time.split(':');
// //     if (!hours || !minutes) return '-';

// //     const hour = parseInt(hours, 10);
// //     if (isNaN(hour)) return '-';

// //     const ampm = hour >= 12 ? 'PM' : 'AM';
// //     const hour12 = hour % 12 || 12;

// //     return `${hour12}:${minutes} ${ampm}`;
// //   };

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     if (storedVendorId) {
// //       setVendorId(storedVendorId);
// //     }
// //   }, []);

// //   const getTableHeight = () => {
// //     const width = window.innerWidth;

// //     if (width <= 600) return "400px";
// //     if (width >= 1000 && width <= 1300) return "400px";
// //     if (width > 1300) return "500px";

// //     return "auto";
// //   };

// //   // Sort timings by day order
// //   const sortTimingsByDay = (timingsArray) => {
// //     return [...timingsArray].sort((a, b) => {
// //       return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
// //     });
// //   };

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     const token = localStorage.getItem("authToken");

// //     if (!storedVendorId || !token) {
// //       alert("Missing vendor ID or authentication token. Please log in again.");
// //       return;
// //     }

// //     const fetchTimings = () => {
// //       axios
// //         .get(
// //           `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
// //           {
// //             headers: {
// //               Authorization: `Bearer ${token}`,
// //             },
// //           }
// //         )
// //         .then((response) => {
// //           const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

// //           const mappedTimings = apiTimings.map((item) => ({
// //             id: item.id,
// //             day: item.day,
// //             open: item.startTime ? item.startTime.substring(0, 5) : '',
// //             close: item.lastTime ? item.lastTime.substring(0, 5) : '',
// //             checked: item.restaurantStatus === 'Open',
// //             restaurantStatus: item.restaurantStatus,
// //             isEditing: false,
// //           }));

// //           // Sort timings after mapping
// //           const sortedTimings = sortTimingsByDay(mappedTimings);
// //           setTimings(sortedTimings);
// //         })
// //         .catch((err) => {
// //           console.error('Failed to fetch timings', err);
// //           setTimings([]);
// //         });
// //     };

// //     fetchTimings();
// //     const intervalId = setInterval(fetchTimings, 10000);

// //     return () => clearInterval(intervalId);
// //   }, []);
// //   const fetchVendorStatus = async () => {
// //     const vendorId = localStorage.getItem("vendorId");
// //     if (!vendorId) return;

// //     try {
// //       const token = localStorage.getItem("authToken");
// //       const response = await axios.get(
// //         `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       if (response.data && typeof response.data.online === "boolean") {
// //         setIsOnline(response.data.online);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching vendor status:", error);
// //     }
// //   };

// //   // ✅ Toggle restaurant open/close
// //   const handleToggleStatus = async (event) => {
// //     const newStatus = event.target.checked;
// //     setIsOnline(newStatus);

// //     const vendorId = localStorage.getItem("vendorId");
// //     if (!vendorId) {
// //       alert("Vendor ID missing!");
// //       return;
// //     }

// //     localStorage.setItem("isOnline", newStatus);

// //     try {
// //       const token = localStorage.getItem("authToken");
// //       const response = await axios.put(
// //         `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
// //         { online: newStatus },
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       //console.log("Status Update Response:", response.data);



// //     } catch (error) {
// //       console.error("Error updating vendor status:", error);

// //       // ❌ Show backend error message if available
// //       if (error.response) {
// //         alert(
// //           `Error: Failed to update status!\n\n` +
// //           JSON.stringify(error.response.data, null, 2)
// //         );
// //       } else {
// //         alert("Network or server error: " + error.message);
// //       }
// //     }
// //   };


// //   const handleAddTiming = () => {
// //     const vendorId = localStorage.getItem("vendorId");
// //     const token = localStorage.getItem("authToken");

// //     if (!vendorId) {
// //       alert("Vendor ID missing. Please refresh or login again.");
// //       return;
// //     }

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (!newTiming.day || !newTiming.open || !newTiming.close) {
// //       alert("Please fill all fields.");
// //       return;
// //     }

// //     // Check if maximum 7 days reached
// //     if (timings.length >= 7) {
// //       alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
// //       return;
// //     }

// //     // Check if day already exists (case-insensitive)
// //     const dayExists = timings.some(timing =>
// //       timing.day.toLowerCase() === newTiming.day.toLowerCase()
// //     );

// //     if (dayExists) {
// //       alert(`Timing for ${newTiming.day} already exists!`);
// //       return;
// //     }

// //     const payload = {
// //       day: newTiming.day,
// //       startTime: newTiming.open + ":00",
// //       lastTime: newTiming.close + ":00",
// //     };

// //     //console.log("Sending payload:", payload);

// //     axios
// //       .post(
// //         `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
// //         payload,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       )
// //       .then((res) => {
// //         //console.log("Success:", res.data);

// //         // Create new timing object
// //         const addedTiming = {
// //           id: res.data.id || Date.now(), // Use response ID or temporary ID
// //           day: res.data.day || newTiming.day,
// //           open: newTiming.open,
// //           close: newTiming.close,
// //           checked: false,
// //           restaurantStatus: 'Open',
// //           isEditing: false,
// //         };

// //         // Add to timings and sort
// //         const updatedTimings = sortTimingsByDay([...timings, addedTiming]);
// //         setTimings(updatedTimings);

// //         alert("Timing added successfully!");
// //         setShowAddModal(false);
// //         setNewTiming({ day: '', open: '', close: '' });
// //       })
// //       .catch((err) => {
// //         console.error("Failed to add timing:", err);
// //         if (err.response) {
// //           console.error("Status:", err.response.status);
// //           console.error("Data:", JSON.stringify(err.response.data, null, 2));
// //           alert("Error adding timing: " + JSON.stringify(err.response.data));
// //         } else {
// //           alert("Network error or server not reachable.");
// //         }
// //       });
// //   };

// //   const handleDeleteTiming = (id) => {
// //     const token = localStorage.getItem("authToken");

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (!window.confirm('Are you sure you want to delete this timing?')) return;

// //     //console.log('Deleting timing with id:', id);

// //     axios
// //       .delete(
// //         `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       )
// //       .then((res) => {
// //         //console.log('Deleted timing:', res.data);
// //         setTimings((prev) => prev.filter((timing) => timing.id !== id));
// //       })
// //       .catch((err) => {
// //         console.error('Failed to delete timing:', err.response?.data || err.message);
// //         alert('Failed to delete timing. Please try again.');
// //       });
// //   };

// //   const toggleEdit = (index) => {
// //     const timing = timings[index];
// //     const token = localStorage.getItem("authToken");

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (timing.isEditing) {
// //       // Only update time fields, not day
// //       const updatedData = {
// //         id: timing.id,
// //         day: timing.day, // Keep the original day
// //         startTime: timing.open + ":00",
// //         lastTime: timing.close + ":00",
// //       };

// //       //console.log("➡️ Sending PUT to edit timing (only time fields):", updatedData);

// //       axios
// //         .put(
// //           `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
// //           updatedData,
// //           {
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`,
// //             },
// //           }
// //         )
// //         .then((res) => {
// //           const updatedTiming = res.data;

// //           // Update the timing in state (only time fields)
// //           setTimings(prev => {
// //             const updated = [...prev];
// //             updated[index] = {
// //               ...updated[index],
// //               // Keep the same day
// //               open: updatedTiming.startTime ? updatedTiming.startTime.substring(0, 5) : timing.open,
// //               close: updatedTiming.lastTime ? updatedTiming.lastTime.substring(0, 5) : timing.close,
// //               isEditing: false,
// //             };
// //             return updated; // No need to re-sort since day doesn't change
// //           });

// //           alert("✅ Timing updated successfully!");
// //         })
// //         .catch((err) => {
// //           console.error("❌ Failed to update timing", err);
// //           console.error("🧾 Response:", err.response?.data);
// //           alert("Failed to save timing. Please try again.");
// //         });
// //     } else {
// //       setTimings(prev => {
// //         const updated = [...prev];
// //         updated[index].isEditing = true;
// //         return updated;
// //       });
// //     }
// //   };
// //   // ✅ Toggle restaurant open/close for a specific day
// //   const handleToggleDayStatus = async (id, currentStatus) => {
// //     const newStatus = !currentStatus;
// //     const token = localStorage.getItem("authToken");

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     // Find the timing item to get its current values
// //     const timingItem = timings.find(item => item.id === id);

// //     //console.log("Current timing item:", timingItem);
// //     //console.log("Toggling from:", currentStatus, "to:", newStatus);

// //     try {
// //       // Create payload with ALL required fields
// //       const payload = {
// //         id: id,
// //         day: timingItem.day, // Include the day
// //         startTime: timingItem.open ? timingItem.open + ":00" : "", // Include open time
// //         lastTime: timingItem.close ? timingItem.close + ":00" : "", // Include close time
// //         restaurantStatus: newStatus ? 'Open' : 'Closed'
// //       };

// //       //console.log("Sending payload to API:", payload);

// //       const response = await axios.put(
// //         `https://backend.maamaas.com/food/api/timings/edit/timings/${id}`,
// //         payload,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       );

// //       //console.log("Day Status Update Response:", response.data);

// //       // Update the status in state
// //       setTimings(prev => {
// //         const updated = prev.map(timing => {
// //           if (timing.id === id) {
// //             return {
// //               ...timing,
// //               checked: newStatus,
// //               restaurantStatus: newStatus ? 'Open' : 'Closed'
// //             };
// //           }
// //           return timing;
// //         });
// //         return sortTimingsByDay(updated);
// //       });

// //     } catch (error) {
// //       console.error("Error updating day status:", error);

// //       if (error.response) {
// //         console.error("Error response data:", error.response.data);
// //         console.error("Error response status:", error.response.status);
// //         alert(
// //           `Error: Failed to update status!\n\n` +
// //           JSON.stringify(error.response.data, null, 2)
// //         );
// //       } else {
// //         alert("Network or server error: " + error.message);
// //       }
// //     }
// //   };
// //   // Fetch on mount
// //   useEffect(() => {
// //     fetchVendorStatus();
// //   }, []);
// //   const handleSubmit = e => {
// //     e.preventDefault();
// //     const savedData = timings.map(({ day, open, close }) => ({ day, open, close }));
// //     //console.log('Saved Timings:', savedData);
// //   };

// //   const handleChange = (index, field, value) => {
// //     setTimings(prev => {
// //       const updated = [...prev];
// //       updated[index][field] = value;
// //       return updated;
// //     });
// //   };

// //   const handleNewTimingChange = (field, value) => {
// //     setNewTiming(prev => ({ ...prev, [field]: value }));
// //   };

// //   // Get available days (days that haven't been added yet)
// //   const getAvailableDays = () => {
// //     const existingDays = timings.map(timing => timing.day);
// //     return dayOrder.filter(day =>
// //       !existingDays.some(existingDay =>
// //         existingDay.toLowerCase() === day.toLowerCase()
// //       )
// //     );
// //   };

// //   // Disable add button if all 7 days are added
// //   const isAddButtonDisabled = timings.length >= 7;

// //   // Set default day when modal opens
// //   const handleOpenAddModal = () => {
// //     const availableDays = getAvailableDays();
// //     setNewTiming({
// //       day: availableDays[0] || '',
// //       open: '',
// //       close: '',
// //     });
// //     setShowAddModal(true);
// //   };

// //   return (
// //     <div style={{ padding: "0px", marginTop: "10px" }}>
// //       <style>{`
// //       `}

// //       </style>
// //       <form onSubmit={handleSubmit}>
// //         {/* Hide the Add button when all 7 days are added */}
// //         <div style={{
// //           display: 'flex',
// //           justifyContent: 'space-between',
// //           alignItems: 'center',
// //           marginBottom: '15px'
// //         }}>
// //           {/* Left side - Add button */}
// //           <button
// //             onClick={handleOpenAddModal}
// //             style={{
// //               padding: '8px 15px',
// //               fontSize: window.innerWidth <= 1300 ? '13px' : '16px',
// //               cursor: timings.length < 7 ? 'pointer' : 'not-allowed',
// //               backgroundColor: timings.length < 7 ? 'rgb(177 92 214)' : 'transparent',
// //               color: timings.length < 7 ? 'white' : 'transparent',
// //               border: timings.length < 7 ? 'none' : '1px solid transparent',
// //               borderRadius: '4px',
// //               fontWeight: 'bold',
// //               opacity: timings.length < 7 ? 1 : 0,
// //               visibility: timings.length < 7 ? 'visible' : 'hidden',
// //             }}
// //             disabled={timings.length >= 7}
// //             title={timings.length >= 7 ? "All 7 days already added" : "Add new timing"}
// //           >
// //             Add +
// //           </button>

// //           {/* Right side - Toggle button */}
// //           <div style={{
// //             display: 'flex',
// //             alignItems: 'center',
// //             gap: '10px'
// //           }}>
// //             <span style={{
// //               fontSize: '16px',
// //               color: '#4e4d4b',
// //               fontWeight: 'bold'
// //             }}>
// //               Restaurant Status:
// //             </span>
// //             <Switch
// //               checked={isOnline}
// //               onChange={handleToggleStatus}
// //               color="primary"
// //               sx={{
// //                 '& .MuiSwitch-switchBase.Mui-checked': {
// //                   color: '#00d807ff',
// //                 },
// //                 '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
// //                   backgroundColor: '#24e22aff',
// //                 },
// //                 '& .MuiSwitch-switchBase': {
// //                   color: '#4e4d4b',
// //                 },
// //                 '& .MuiSwitch-track': {
// //                   backgroundColor: '#727170ff',
// //                 },
// //               }}
// //             />
// //             <span style={{
// //               fontSize: '16px',
// //               color: isOnline ? '#00d807ff' : '#4e4d4b',
// //               fontWeight: 'bold',
// //               minWidth: '60px'
// //             }}>
// //               {isOnline ? "Open" : "Closed"}
// //             </span>
// //           </div>
// //         </div>

// //         {showAddModal && (
// //           <div
// //             style={{
// //               position: 'fixed',
// //               top: 0, left: 0, right: 0, bottom: 0,
// //               backgroundColor: 'rgba(0,0,0,0.5)',
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'center',
// //               zIndex: 1000,
// //             }}
// //           >
// //             <div
// //               style={{
// //                 backgroundColor: 'white',
// //                 padding: '24px',
// //                 borderRadius: '10px',
// //                 width: '360px',
// //                 boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
// //                 position: 'relative',
// //                 fontFamily: 'Arial, sans-serif',
// //               }}
// //             >
// //               <button
// //                 onClick={() => setShowAddModal(false)}
// //                 style={{
// //                   position: 'absolute',
// //                   top: '10px',
// //                   right: '10px',
// //                   color: '#000',
// //                   border: 'none',
// //                   borderRadius: '50%',
// //                   width: '30px',
// //                   height: '30px',
// //                   fontSize: '16px',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                 }}
// //                 aria-label="Close modal"
// //               >
// //                 <FaTimes />
// //               </button>

// //               <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>

// //               <div style={{ marginBottom: '15px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
// //                 <select
// //                   value={newTiming.day}
// //                   onChange={e => handleNewTimingChange('day', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                 >
// //                   {getAvailableDays().map(day => (
// //                     <option key={day} value={day}>{day}</option>
// //                   ))}
// //                 </select>
// //                 {getAvailableDays().length === 0 && (
// //                   <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
// //                     All days have been added!
// //                   </div>
// //                 )}
// //               </div>

// //               <div style={{ marginBottom: '15px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
// //                 <input
// //                   type="time"
// //                   value={newTiming.open}
// //                   onChange={e => handleNewTimingChange('open', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                   required
// //                 />
// //                 {newTiming.open && (
// //                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
// //                     Selected: {formatTimeToAMPM(newTiming.open)}
// //                   </div>
// //                 )}
// //               </div>

// //               <div style={{ marginBottom: '20px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
// //                 <input
// //                   type="time"
// //                   value={newTiming.close}
// //                   onChange={e => handleNewTimingChange('close', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                   required
// //                 />
// //                 {newTiming.close && (
// //                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
// //                     Selected: {formatTimeToAMPM(newTiming.close)}
// //                   </div>
// //                 )}
// //               </div>

// //               <div style={{ textAlign: 'center' }}>
// //                 <button
// //                   onClick={handleAddTiming}
// //                   disabled={getAvailableDays().length === 0 || !newTiming.open || !newTiming.close}
// //                   style={{
// //                     padding: '10px 20px',
// //                     cursor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 'not-allowed' : 'pointer',
// //                     backgroundColor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? '#cccccc' : 'rgb(177, 92, 214)',
// //                     color: 'white',
// //                     border: 'none',
// //                     borderRadius: '5px',
// //                     fontSize: '15px',
// //                     opacity: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 0.6 : 1,
// //                   }}
// //                 >
// //                   Save
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         <div style={{ height: getTableHeight(), overflowY: "auto" }}>
// //           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
// //             <thead>
// //               <tr>
// //                 <th style={tableHeaderStyle}>S.No</th>
// //                 <th style={tableHeaderStyle}>Day</th>
// //                 <th style={tableHeaderStyle}>Open Time</th>
// //                 <th style={tableHeaderStyle}>Close Time</th>
// //                 <th style={tableHeaderStyle}>Action</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {timings.map((item, index) => (
// //                 <tr key={item.id || item.day}>
// //                   <td style={tableCellStyle}>{index + 1}</td>
// //                   <td style={tableCellStyle}>
// //                     {/* Day is NOT editable - always show as text */}
// //                     {item.day}
// //                   </td>
// //                   <td style={tableCellStyle}>
// //                     {item.isEditing ? (
// //                       <input
// //                         type="time"
// //                         value={item.open}
// //                         onChange={e => handleChange(index, 'open', e.target.value)}
// //                         style={{ ...inputStyle, }}
// //                       />
// //                     ) : (
// //                       formatTimeToAMPM(item.open)
// //                     )}
// //                   </td>
// //                   <td style={tableCellStyle}>
// //                     {item.isEditing ? (
// //                       <input
// //                         type="time"
// //                         value={item.close}
// //                         onChange={e => handleChange(index, 'close', e.target.value)}
// //                         style={inputStyle}
// //                       />
// //                     ) : (
// //                       formatTimeToAMPM(item.close)
// //                     )}
// //                   </td>
// //                   <td style={tableCellStyle}>
// //                     <button
// //                       type="button"
// //                       onClick={() => toggleEdit(index)}
// //                       style={{
// //                         ...buttonStyle,
// //                         background: 'none',
// //                         border: 'none',
// //                         cursor: 'pointer',
// //                         fontSize: '18px',
// //                         color: '#4A148C',
// //                         marginRight: '8px',
// //                       }}
// //                     >
// //                       {item.isEditing ? <FaSave /> : <FaEdit />}
// //                     </button>
// //                     {/* <button
// //                       type="button"
// //                       onClick={() => handleDeleteTiming(item.id)}
// //                       style={{
// //                         ...buttonStyle,
// //                         background: 'none',
// //                         border: 'none',
// //                         cursor: 'pointer',
// //                         fontSize: '18px',
// //                         color: 'red',
// //                       }}
// //                       title="Delete Timing"
// //                     >
// //                       <FaTrash />
// //                     </button> */}
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </div>
// //       </form>
// //     </div>
// //   );
// // };

// // const tableHeaderStyle = {
// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// //   fontWeight: 'bold',
// //   backgroundColor: '#b15cd6',
// //   color: 'white',
// //   padding: "8px",
// //   whiteSpace: "nowrap",
// // };

// // const tableCellStyle = {
// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// // };

// // const inputStyle = {
// //   width: '100%',
// //   border: 'none',
// //   backgroundColor: 'transparent',
// //   textAlign: 'center',
// // };

// // const buttonStyle = {
// //   backgroundColor: '#dc3545',
// //   color: 'white',
// //   border: 'none',
// //   borderRadius: '4px',
// //   cursor: 'pointer',
// //   marginRight: "5px"
// // };

// // export default Timings;




// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
// import { FaTimes } from 'react-icons/fa';
// import { Switch } from "@mui/material";

// const Timings = () => {
//   const [vendorId, setVendorId] = useState(null);
//   const [timings, setTimings] = useState([]);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [newTiming, setNewTiming] = useState({
//     day: '',
//     open: '',
//     close: '',
//     restaurantStatus: 'Open' // Default status
//   });
//   const [isOnline, setIsOnline] = useState(false);

//   // ✅ Get saved online/offline status
//   useEffect(() => {
//     const savedStatus = localStorage.getItem("isOnline");
//     if (savedStatus !== null) {
//       setIsOnline(savedStatus === "true");
//     }
//   }, []);

//   // Define the correct order of days
//   const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

//   // Function to format time to AM/PM format
//   const formatTimeToAMPM = (timeString) => {
//     if (!timeString || timeString === '-' || timeString === '') return '-';

//     // Remove seconds if present (e.g., "14:30:00" -> "14:30")
//     const time = timeString.split(':').slice(0, 2).join(':');

//     // Check if time is already in 12-hour format (contains AM/PM)
//     if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
//       return timeString;
//     }

//     // Convert to AM/PM format
//     const [hours, minutes] = time.split(':');
//     if (!hours || !minutes) return '-';

//     const hour = parseInt(hours, 10);
//     if (isNaN(hour)) return '-';

//     const ampm = hour >= 12 ? 'PM' : 'AM';
//     const hour12 = hour % 12 || 12;

//     return `${hour12}:${minutes} ${ampm}`;
//   };

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//     }
//   }, []);

//   const getTableHeight = () => {
//     const width = window.innerWidth;

//     if (width <= 600) return "400px";
//     if (width >= 1000 && width <= 1300) return "400px";
//     if (width > 1300) return "500px";

//     return "auto";
//   };

//   // Sort timings by day order
//   const sortTimingsByDay = (timingsArray) => {
//     return [...timingsArray].sort((a, b) => {
//       return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
//     });
//   };

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken");

//     if (!storedVendorId || !token) {
//       alert("Missing vendor ID or authentication token. Please log in again.");
//       return;
//     }

//     const fetchTimings = () => {
//       axios
//         .get(
//           `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         )
//         .then((response) => {
//           const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

//           const mappedTimings = apiTimings.map((item) => ({
//             id: item.id,
//             day: item.day,
//             open: item.startTime ? item.startTime.substring(0, 5) : '',
//             close: item.lastTime ? item.lastTime.substring(0, 5) : '',
//             restaurantStatus: item.restaurantStatus || 'Open', // Get status from API
//             isEditing: false,
//             isStatusEditing: false // New flag for status editing
//           }));

//           // Sort timings after mapping
//           const sortedTimings = sortTimingsByDay(mappedTimings);
//           setTimings(sortedTimings);
//         })
//         .catch((err) => {
//           console.error('Failed to fetch timings', err);
//           setTimings([]);
//         });
//     };

//     fetchTimings();
//     const intervalId = setInterval(fetchTimings, 10000);

//     return () => clearInterval(intervalId);
//   }, []);
  
//   const fetchVendorStatus = async () => {
//     const vendorId = localStorage.getItem("vendorId");
//     if (!vendorId) return;

//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (response.data && typeof response.data.online === "boolean") {
//         setIsOnline(response.data.online);
//       }
//     } catch (error) {
//       console.error("Error fetching vendor status:", error);
//     }
//   };

//   // ✅ Toggle restaurant open/close
//   const handleToggleStatus = async (event) => {
//     const newStatus = event.target.checked;
//     setIsOnline(newStatus);

//     const vendorId = localStorage.getItem("vendorId");
//     if (!vendorId) {
//       alert("Vendor ID missing!");
//       return;
//     }

//     localStorage.setItem("isOnline", newStatus);

//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
//         { online: newStatus },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       //console.log("Status Update Response:", response.data);

//     } catch (error) {
//       console.error("Error updating vendor status:", error);
//       if (error.response) {
//         alert(
//           `Error: Failed to update status!\n\n` +
//           JSON.stringify(error.response.data, null, 2)
//         );
//       } else {
//         alert("Network or server error: " + error.message);
//       }
//     }
//   };

//   const handleAddTiming = () => {
//     const vendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken");

//     if (!vendorId) {
//       alert("Vendor ID missing. Please refresh or login again.");
//       return;
//     }

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (!newTiming.day || !newTiming.open || !newTiming.close) {
//       alert("Please fill all fields.");
//       return;
//     }

//     // Check if maximum 7 days reached
//     if (timings.length >= 7) {
//       alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
//       return;
//     }

//     // Check if day already exists (case-insensitive)
//     const dayExists = timings.some(timing =>
//       timing.day.toLowerCase() === newTiming.day.toLowerCase()
//     );

//     if (dayExists) {
//       alert(`Timing for ${newTiming.day} already exists!`);
//       return;
//     }

//     const payload = {
//       day: newTiming.day,
//       startTime: newTiming.open + ":00",
//       lastTime: newTiming.close + ":00",
//       restaurantStatus: newTiming.restaurantStatus // Include status
//     };

//     //console.log("Sending payload:", payload);

//     axios
//       .post(
//         `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then((res) => {
//         //console.log("Success:", res.data);

//         // Create new timing object
//         const addedTiming = {
//           id: res.data.id || Date.now(),
//           day: res.data.day || newTiming.day,
//           open: newTiming.open,
//           close: newTiming.close,
//           restaurantStatus: newTiming.restaurantStatus,
//           isEditing: false,
//           isStatusEditing: false
//         };

//         // Add to timings and sort
//         const updatedTimings = sortTimingsByDay([...timings, addedTiming]);
//         setTimings(updatedTimings);

//         alert("Timing added successfully!");
//         setShowAddModal(false);
//         setNewTiming({ day: '', open: '', close: '', restaurantStatus: 'Open' });
//       })
//       .catch((err) => {
//         console.error("Failed to add timing:", err);
//         if (err.response) {
//           console.error("Status:", err.response.status);
//           console.error("Data:", JSON.stringify(err.response.data, null, 2));
//           alert("Error adding timing: " + JSON.stringify(err.response.data));
//         } else {
//           alert("Network error or server not reachable.");
//         }
//       });
//   };

//   const handleDeleteTiming = (id) => {
//     const token = localStorage.getItem("authToken");

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (!window.confirm('Are you sure you want to delete this timing?')) return;

//     //console.log('Deleting timing with id:', id);

//     axios
//       .delete(
//         `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then((res) => {
//         //console.log('Deleted timing:', res.data);
//         setTimings((prev) => prev.filter((timing) => timing.id !== id));
//       })
//       .catch((err) => {
//         console.error('Failed to delete timing:', err.response?.data || err.message);
//         alert('Failed to delete timing. Please try again.');
//       });
//   };

//   const toggleEdit = (index) => {
//     const timing = timings[index];
//     const token = localStorage.getItem("authToken");

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (timing.isEditing) {
//       // Only update time fields, not day
//       const updatedData = {
//         id: timing.id,
//         day: timing.day, // Keep the original day
//         startTime: timing.open + ":00",
//         lastTime: timing.close + ":00",
//         restaurantStatus: timing.restaurantStatus // Include status
//       };

//       //console.log("➡️ Sending PUT to edit timing:", updatedData);

//       axios
//         .put(
//           `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
//           updatedData,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         )
//         .then((res) => {
//           const updatedTiming = res.data;

//           // Update the timing in state
//           setTimings(prev => {
//             const updated = [...prev];
//             updated[index] = {
//               ...updated[index],
//               open: updatedTiming.startTime ? updatedTiming.startTime.substring(0, 5) : timing.open,
//               close: updatedTiming.lastTime ? updatedTiming.lastTime.substring(0, 5) : timing.close,
//               restaurantStatus: updatedTiming.restaurantStatus || timing.restaurantStatus,
//               isEditing: false,
//             };
//             return updated;
//           });

//           alert("✅ Timing updated successfully!");
//         })
//         .catch((err) => {
//           console.error("❌ Failed to update timing", err);
//           console.error("🧾 Response:", err.response?.data);
//           alert("Failed to save timing. Please try again.");
//         });
//     } else {
//       setTimings(prev => {
//         const updated = [...prev];
//         updated[index].isEditing = true;
//         return updated;
//       });
//     }
//   };

//   // Toggle status editing mode
//   const toggleStatusEdit = (index) => {
//     setTimings(prev => {
//       const updated = [...prev];
//       updated[index].isStatusEditing = !updated[index].isStatusEditing;
//       return updated;
//     });
//   };

//   // Save status changes
//   const saveStatus = async (index) => {
//     const timing = timings[index];
//     const token = localStorage.getItem("authToken");

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     try {
//       const payload = {
//         id: timing.id,
//         day: timing.day,
//         startTime: timing.open ? timing.open + ":00" : "",
//         lastTime: timing.close ? timing.close + ":00" : "",
//         restaurantStatus: timing.restaurantStatus
//       };

//       //console.log("Saving status payload:", payload);

//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       //console.log("Status Save Response:", response.data);

//       // Update the status in state
//       setTimings(prev => {
//         const updated = [...prev];
//         updated[index] = {
//           ...updated[index],
//           isStatusEditing: false
//         };
//         return updated;
//       });

//       alert("✅ Status updated successfully!");
//     } catch (error) {
//       console.error("Error saving status:", error);
//       if (error.response) {
//         alert(
//           `Error: Failed to update status!\n\n` +
//           JSON.stringify(error.response.data, null, 2)
//         );
//       } else {
//         alert("Network or server error: " + error.message);
//       }
//     }
//   };

//   // Handle status change
//   const handleStatusChange = (index, newStatus) => {
//     setTimings(prev => {
//       const updated = [...prev];
//       updated[index].restaurantStatus = newStatus;
//       return updated;
//     });
//   };

//   // Fetch on mount
//   useEffect(() => {
//     fetchVendorStatus();
//   }, []);
  
//   const handleSubmit = e => {
//     e.preventDefault();
//     const savedData = timings.map(({ day, open, close, restaurantStatus }) => ({ 
//       day, open, close, restaurantStatus 
//     }));
//     //console.log('Saved Timings:', savedData);
//   };

//   const handleChange = (index, field, value) => {
//     setTimings(prev => {
//       const updated = [...prev];
//       updated[index][field] = value;
//       return updated;
//     });
//   };

//   const handleNewTimingChange = (field, value) => {
//     setNewTiming(prev => ({ ...prev, [field]: value }));
//   };

//   // Get available days (days that haven't been added yet)
//   const getAvailableDays = () => {
//     const existingDays = timings.map(timing => timing.day);
//     return dayOrder.filter(day =>
//       !existingDays.some(existingDay =>
//         existingDay.toLowerCase() === day.toLowerCase()
//       )
//     );
//   };

//   // Disable add button if all 7 days are added
//   const isAddButtonDisabled = timings.length >= 7;

//   // Set default day when modal opens
//   const handleOpenAddModal = () => {
//     const availableDays = getAvailableDays();
//     setNewTiming({
//       day: availableDays[0] || '',
//       open: '',
//       close: '',
//       restaurantStatus: 'Open'
//     });
//     setShowAddModal(true);
//   };

//   return (
//     <div style={{ padding: "0px", marginTop: "10px" }}>
//       <form onSubmit={handleSubmit}>
//         {/* Hide the Add button when all 7 days are added */}
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '15px'
//         }}>
//           {/* Left side - Add button */}
//           <button
//             onClick={handleOpenAddModal}
//             style={{
//               padding: '8px 15px',
//               fontSize: window.innerWidth <= 1300 ? '13px' : '16px',
//               cursor: timings.length < 7 ? 'pointer' : 'not-allowed',
//               backgroundColor: timings.length < 7 ? 'rgb(177 92 214)' : 'transparent',
//               color: timings.length < 7 ? 'white' : 'transparent',
//               border: timings.length < 7 ? 'none' : '1px solid transparent',
//               borderRadius: '4px',
//               fontWeight: 'bold',
//               opacity: timings.length < 7 ? 1 : 0,
//               visibility: timings.length < 7 ? 'visible' : 'hidden',
//             }}
//             disabled={timings.length >= 7}
//             title={timings.length >= 7 ? "All 7 days already added" : "Add new timing"}
//           >
//             Add +
//           </button>

//           {/* Right side - Toggle button */}
//           <div style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '10px'
//           }}>
//             <span style={{
//               fontSize: '16px',
//               color: '#4e4d4b',
//               fontWeight: 'bold'
//             }}>
//               Restaurant Status:
//             </span>
//             <Switch
//               checked={isOnline}
//               onChange={handleToggleStatus}
//               color="primary"
//               sx={{
//                 '& .MuiSwitch-switchBase.Mui-checked': {
//                   color: '#00d807ff',
//                 },
//                 '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
//                   backgroundColor: '#24e22aff',
//                 },
//                 '& .MuiSwitch-switchBase': {
//                   color: '#4e4d4b',
//                 },
//                 '& .MuiSwitch-track': {
//                   backgroundColor: '#727170ff',
//                 },
//               }}
//             />
//             <span style={{
//               fontSize: '16px',
//               color: isOnline ? '#00d807ff' : '#4e4d4b',
//               fontWeight: 'bold',
//               minWidth: '60px'
//             }}>
//               {isOnline ? "Open" : "Closed"}
//             </span>
//           </div>
//         </div>

//         {showAddModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0, left: 0, right: 0, bottom: 0,
//               backgroundColor: 'rgba(0,0,0,0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000,
//             }}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '24px',
//                 borderRadius: '10px',
//                 width: '360px',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
//                 position: 'relative',
//                 fontFamily: 'Arial, sans-serif',
//               }}
//             >
//               <button
//                 onClick={() => setShowAddModal(false)}
//                 style={{
//                   position: 'absolute',
//                   top: '10px',
//                   right: '10px',
//                   color: '#000',
//                   border: 'none',
//                   borderRadius: '50%',
//                   width: '30px',
//                   height: '30px',
//                   fontSize: '16px',
//                   cursor: 'pointer',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                 }}
//                 aria-label="Close modal"
//               >
//                 <FaTimes />
//               </button>

//               <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
//                 <select
//                   value={newTiming.day}
//                   onChange={e => handleNewTimingChange('day', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                 >
//                   {getAvailableDays().map(day => (
//                     <option key={day} value={day}>{day}</option>
//                   ))}
//                 </select>
//                 {getAvailableDays().length === 0 && (
//                   <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
//                     All days have been added!
//                   </div>
//                 )}
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
//                 <input
//                   type="time"
//                   value={newTiming.open}
//                   onChange={e => handleNewTimingChange('open', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                   required
//                 />
//                 {newTiming.open && (
//                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
//                     Selected: {formatTimeToAMPM(newTiming.open)}
//                   </div>
//                 )}
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
//                 <input
//                   type="time"
//                   value={newTiming.close}
//                   onChange={e => handleNewTimingChange('close', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                   required
//                 />
//                 {newTiming.close && (
//                   <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
//                     Selected: {formatTimeToAMPM(newTiming.close)}
//                   </div>
//                 )}
//               </div>

//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Status:</label>
//                 <select
//                   value={newTiming.restaurantStatus}
//                   onChange={e => handleNewTimingChange('restaurantStatus', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                 >
//                   <option value="Open">Open</option>
//                   <option value="Closed">Closed</option>
//                 </select>
//               </div>

//               <div style={{ textAlign: 'center' }}>
//                 <button
//                   onClick={handleAddTiming}
//                   disabled={getAvailableDays().length === 0 || !newTiming.open || !newTiming.close}
//                   style={{
//                     padding: '10px 20px',
//                     cursor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 'not-allowed' : 'pointer',
//                     backgroundColor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? '#cccccc' : 'rgb(177, 92, 214)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     fontSize: '15px',
//                     opacity: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 0.6 : 1,
//                   }}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         <div style={{ height: getTableHeight(), overflowY: "auto" }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
//             <thead>
//               <tr>
//                 <th style={tableHeaderStyle}>S.No</th>
//                 <th style={tableHeaderStyle}>Day</th>
//                 <th style={tableHeaderStyle}>Open Time</th>
//                 <th style={tableHeaderStyle}>Close Time</th>
//                 <th style={tableHeaderStyle}>Status</th> {/* New Status Column */}
//                 <th style={tableHeaderStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {timings.map((item, index) => (
//                 <tr key={item.id || item.day}>
//                   <td style={tableCellStyle}>{index + 1}</td>
//                   <td style={tableCellStyle}>
//                     {item.day}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {item.isEditing ? (
//                       <input
//                         type="time"
//                         value={item.open}
//                         onChange={e => handleChange(index, 'open', e.target.value)}
//                         style={{ ...inputStyle }}
//                       />
//                     ) : (
//                       formatTimeToAMPM(item.open)
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {item.isEditing ? (
//                       <input
//                         type="time"
//                         value={item.close}
//                         onChange={e => handleChange(index, 'close', e.target.value)}
//                         style={inputStyle}
//                       />
//                     ) : (
//                       formatTimeToAMPM(item.close)
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {item.isStatusEditing ? (
//                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
//                         <select
//                           value={item.restaurantStatus}
//                           onChange={e => handleStatusChange(index, e.target.value)}
//                           style={{
//                             padding: '4px 8px',
//                             border: '1px solid #ccc',
//                             borderRadius: '4px',
//                             fontSize: '14px',
//                             minWidth: '100px'
//                           }}
//                         >
//                           <option value="Open">Open</option>
//                           <option value="Closed">Closed</option>
//                         </select>
//                         <button
//                           onClick={() => saveStatus(index)}
//                           style={{
//                             padding: '4px 8px',
//                             backgroundColor: '#4CAF50',
//                             color: 'white',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer',
//                             fontSize: '12px'
//                           }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           onClick={() => toggleStatusEdit(index)}
//                           style={{
//                             padding: '4px 8px',
//                             backgroundColor: '#f44336',
//                             color: 'white',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer',
//                             fontSize: '12px'
//                           }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
//                         <span style={{
//                           color: item.restaurantStatus === 'Open' ? '#4CAF50' : '#f44336',
//                           fontWeight: 'bold',
//                           padding: '4px 12px',
//                           borderRadius: '4px',
//                           backgroundColor: item.restaurantStatus === 'Open' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
//                           minWidth: '80px'
//                         }}>
//                           {item.restaurantStatus}
//                         </span>
//                         <button
//                           onClick={() => toggleStatusEdit(index)}
//                           style={{
//                             background: 'none',
//                             border: 'none',
//                             cursor: 'pointer',
//                             fontSize: '14px',
//                             color: '#4A148C',
//                           }}
//                           title="Edit Status"
//                         >
//                           <FaEdit />
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     <button
//                       type="button"
//                       onClick={() => toggleEdit(index)}
//                       style={{
//                         ...buttonStyle,
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '18px',
//                         color: '#4A148C',
//                         marginRight: '8px',
//                       }}
//                       title="Edit Time"
//                     >
//                       {item.isEditing ? <FaSave /> : <FaEdit />}
//                     </button>
//                     {/* <button
//                       type="button"
//                       onClick={() => handleDeleteTiming(item.id)}
//                       style={{
//                         ...buttonStyle,
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '18px',
//                         color: 'red',
//                       }}
//                       title="Delete Timing"
//                     >
//                       <FaTrash />
//                     </button> */}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </form>
//     </div>
//   );
// };

// const tableHeaderStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   fontWeight: 'bold',
//   backgroundColor: '#b15cd6',
//   color: 'white',
//   padding: "8px",
//   whiteSpace: "nowrap",
// };

// const tableCellStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   padding: "8px",
// };

// const inputStyle = {
//   width: '100%',
//   border: 'none',
//   backgroundColor: 'transparent',
//   textAlign: 'center',
// };

// const buttonStyle = {
//   backgroundColor: '#dc3545',
//   color: 'white',
//   border: 'none',
//   borderRadius: '4px',
//   cursor: 'pointer',
//   marginRight: "5px"
// };

// export default Timings;








import React, { useState, useEffect } from "react";
import axios from 'axios';
import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';
import { Switch } from "@mui/material";

const Timings = () => {
  const [vendorId, setVendorId] = useState(null);
  const [timings, setTimings] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newTiming, setNewTiming] = useState({
    day: '',
    open: '',
    close: '',
    restaurantStatus: 'Open'
  });
  const [isOnline, setIsOnline] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  // Update current time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000); // Update every minute
    
    return () => clearInterval(interval);
  }, []);

  // ✅ Get saved online/offline status
  useEffect(() => {
    const savedStatus = localStorage.getItem("isOnline");
    if (savedStatus !== null) {
      setIsOnline(savedStatus === "true");
    }
  }, []);

  // Define the correct order of days
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  
  // Map day names to match JavaScript Date.getDay() (0=Sunday, 1=Monday, etc.)
  const dayMap = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  };

  // Function to get current day name
  const getCurrentDayName = () => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[currentDateTime.getDay()];
  };

  // Function to check if a time is between open and close times
  const isTimeBetween = (currentTime, openTime, closeTime) => {
    if (!openTime || !closeTime || openTime === '-' || closeTime === '-') {
      return false;
    }

    // Parse times (format: "HH:MM" or "HH:MM AM/PM")
    const parseTime = (timeStr) => {
      let time = timeStr.trim().toUpperCase();
      
      // Handle AM/PM format
      if (time.includes('AM') || time.includes('PM')) {
        const [timePart, modifier] = time.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);
        
        if (modifier === 'PM' && hours < 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
        
        return hours * 60 + minutes; // Convert to minutes
      } else {
        // Handle 24-hour format
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      }
    };

    // Parse current time
    const currentHours = currentDateTime.getHours();
    const currentMinutes = currentDateTime.getMinutes();
    const currentTotalMinutes = currentHours * 60 + currentMinutes;

    const openMinutes = parseTime(openTime);
    const closeMinutes = parseTime(closeTime);

    // Handle overnight hours (e.g., 22:00 to 02:00 next day)
    if (closeMinutes < openMinutes) {
      // Closing time is next day
      return currentTotalMinutes >= openMinutes || currentTotalMinutes <= closeMinutes;
    } else {
      // Normal case
      return currentTotalMinutes >= openMinutes && currentTotalMinutes <= closeMinutes;
    }
  };

  // Function to calculate status based on current day and time
  const calculateStatus = (day, openTime, closeTime, savedStatus) => {
    const currentDayName = getCurrentDayName();
    
    // If it's not the current day, show "Closed"
    if (day !== currentDayName) {
      return {
        status: 'Closed',
        isDynamic: false,
        reason: `Not ${currentDayName}`
      };
    }
    
    // If it's the current day, check time
    if (!openTime || !closeTime || openTime === '-' || closeTime === '-') {
      return {
        status: 'Closed',
        isDynamic: false,
        reason: 'No timings set'
      };
    }

    const isOpenNow = isTimeBetween(currentDateTime, openTime, closeTime);
    
    return {
      status: isOpenNow ? 'Open' : 'Closed',
      isDynamic: true,
      // reason: isOpenNow ? 'Within business hours' : 'Outside business hours'
    };
  };

  // Function to format time to AM/PM format
  const formatTimeToAMPM = (timeString) => {
    if (!timeString || timeString === '-' || timeString === '') return '-';

    // Remove seconds if present (e.g., "14:30:00" -> "14:30")
    const time = timeString.split(':').slice(0, 2).join(':');

    // Check if time is already in 12-hour format (contains AM/PM)
    if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
      return timeString;
    }

    // Convert to AM/PM format
    const [hours, minutes] = time.split(':');
    if (!hours || !minutes) return '-';

    const hour = parseInt(hours, 10);
    if (isNaN(hour)) return '-';

    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  const getTableHeight = () => {
    const width = window.innerWidth;

    if (width <= 600) return "400px";
    if (width >= 1000 && width <= 1300) return "400px";
    if (width > 1300) return "500px";

    return "auto";
  };

  // Sort timings by day order
  const sortTimingsByDay = (timingsArray) => {
    return [...timingsArray].sort((a, b) => {
      return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
    });
  };

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!storedVendorId || !token) {
      alert("Missing vendor ID or authentication token. Please log in again.");
      return;
    }

    const fetchTimings = () => {
      axios
        .get(
          `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

          const mappedTimings = apiTimings.map((item) => ({
            id: item.id,
            day: item.day,
            open: item.startTime ? item.startTime.substring(0, 5) : '',
            close: item.lastTime ? item.lastTime.substring(0, 5) : '',
            restaurantStatus: item.restaurantStatus || 'Open',
            isEditing: false,
            isStatusEditing: false
          }));

          // Sort timings after mapping
          const sortedTimings = sortTimingsByDay(mappedTimings);
          setTimings(sortedTimings);
        })
        .catch((err) => {
          console.error('Failed to fetch timings', err);
          setTimings([]);
        });
    };

    fetchTimings();
    const intervalId = setInterval(fetchTimings, 10000);

    return () => clearInterval(intervalId);
  }, []);
  
  const fetchVendorStatus = async () => {
    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) return;

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data && typeof response.data.online === "boolean") {
        setIsOnline(response.data.online);
      }
    } catch (error) {
      console.error("Error fetching vendor status:", error);
    }
  };

  // ✅ Toggle restaurant open/close
  const handleToggleStatus = async (event) => {
    const newStatus = event.target.checked;
    setIsOnline(newStatus);

    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) {
      alert("Vendor ID missing!");
      return;
    }

    localStorage.setItem("isOnline", newStatus);

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
        { online: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );


    } catch (error) {
      console.error("Error updating vendor status:", error);
      if (error.response) {
        alert(
          `Error: Failed to update status!\n\n` +
          JSON.stringify(error.response.data, null, 2)
        );
      } else {
        alert("Network or server error: " + error.message);
      }
    }
  };

  const handleAddTiming = () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId) {
      alert("Vendor ID missing. Please refresh or login again.");
      return;
    }

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    if (!newTiming.day || !newTiming.open || !newTiming.close) {
      alert("Please fill all fields.");
      return;
    }

    // Check if maximum 7 days reached
    if (timings.length >= 7) {
      alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
      return;
    }

    // Check if day already exists (case-insensitive)
    const dayExists = timings.some(timing =>
      timing.day.toLowerCase() === newTiming.day.toLowerCase()
    );

    if (dayExists) {
      alert(`Timing for ${newTiming.day} already exists!`);
      return;
    }

    const payload = {
      day: newTiming.day,
      startTime: newTiming.open + ":00",
      lastTime: newTiming.close + ":00",
      restaurantStatus: newTiming.restaurantStatus
    };


    axios
      .post(
        `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {

        const addedTiming = {
          id: res.data.id || Date.now(),
          day: res.data.day || newTiming.day,
          open: newTiming.open,
          close: newTiming.close,
          restaurantStatus: newTiming.restaurantStatus,
          isEditing: false,
          isStatusEditing: false
        };

        const updatedTimings = sortTimingsByDay([...timings, addedTiming]);
        setTimings(updatedTimings);

        alert("Timing added successfully!");
        setShowAddModal(false);
        setNewTiming({ day: '', open: '', close: '', restaurantStatus: 'Open' });
      })
      .catch((err) => {
        console.error("Failed to add timing:", err);
        if (err.response) {
          console.error("Status:", err.response.status);
          console.error("Data:", JSON.stringify(err.response.data, null, 2));
          alert("Error adding timing: " + JSON.stringify(err.response.data));
        } else {
          alert("Network error or server not reachable.");
        }
      });
  };

  // Toggle edit mode
  const toggleEdit = (index) => {
    const timing = timings[index];
    const token = localStorage.getItem("authToken");

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    if (timing.isEditing) {
      const updatedData = {
        id: timing.id,
        day: timing.day,
        startTime: timing.open + ":00",
        lastTime: timing.close + ":00",
        restaurantStatus: timing.restaurantStatus
      };


      axios
        .put(
          `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
          updatedData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const updatedTiming = res.data;

          setTimings(prev => {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              open: updatedTiming.startTime ? updatedTiming.startTime.substring(0, 5) : timing.open,
              close: updatedTiming.lastTime ? updatedTiming.lastTime.substring(0, 5) : timing.close,
              restaurantStatus: updatedTiming.restaurantStatus || timing.restaurantStatus,
              isEditing: false,
            };
            return updated;
          });

          alert("✅ Timing updated successfully!");
        })
        .catch((err) => {
          console.error("❌ Failed to update timing", err);
          alert("Failed to save timing. Please try again.");
        });
    } else {
      setTimings(prev => {
        const updated = [...prev];
        updated[index].isEditing = true;
        return updated;
      });
    }
  };

  // Fetch on mount
  useEffect(() => {
    fetchVendorStatus();
  }, []);
  
  const handleSubmit = e => {
    e.preventDefault();
    const savedData = timings.map(({ day, open, close, restaurantStatus }) => ({ 
      day, open, close, restaurantStatus 
    }));
  };

  const handleChange = (index, field, value) => {
    setTimings(prev => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handleNewTimingChange = (field, value) => {
    setNewTiming(prev => ({ ...prev, [field]: value }));
  };

  // Get available days (days that haven't been added yet)
  const getAvailableDays = () => {
    const existingDays = timings.map(timing => timing.day);
    return dayOrder.filter(day =>
      !existingDays.some(existingDay =>
        existingDay.toLowerCase() === day.toLowerCase()
      )
    );
  };

  // Disable add button if all 7 days are added
  const isAddButtonDisabled = timings.length >= 7;

  // Set default day when modal opens
  const handleOpenAddModal = () => {
    const availableDays = getAvailableDays();
    setNewTiming({
      day: availableDays[0] || '',
      open: '',
      close: '',
      restaurantStatus: 'Open'
    });
    setShowAddModal(true);
  };

  // Display current time and day info
  const currentDayName = getCurrentDayName();
  const currentTimeStr = currentDateTime.toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  });

  return (
    <div style={{ padding: "0px", marginTop: "10px" }}>
 

      <form onSubmit={handleSubmit}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '15px'
        }}>
          {/* Left side - Add button */}
          <button
            onClick={handleOpenAddModal}
            style={{
              padding: '8px 15px',
              fontSize: window.innerWidth <= 1300 ? '13px' : '16px',
              cursor: timings.length < 7 ? 'pointer' : 'not-allowed',
              backgroundColor: timings.length < 7 ? 'rgb(177 92 214)' : 'transparent',
              color: timings.length < 7 ? 'white' : 'transparent',
              border: timings.length < 7 ? 'none' : '1px solid transparent',
              borderRadius: '4px',
              fontWeight: 'bold',
              opacity: timings.length < 7 ? 1 : 0,
              visibility: timings.length < 7 ? 'visible' : 'hidden',
            }}
            disabled={timings.length >= 7}
            title={timings.length >= 7 ? "All 7 days already added" : "Add new timing"}
          >
            Add +
          </button>

          {/* Right side - Toggle button */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{
              fontSize: '16px',
              color: '#4e4d4b',
              fontWeight: 'bold'
            }}>
              Restaurant Status:
            </span>
            <Switch
              checked={isOnline}
              onChange={handleToggleStatus}
              color="primary"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#00d807ff',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#24e22aff',
                },
                '& .MuiSwitch-switchBase': {
                  color: '#4e4d4b',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#727170ff',
                },
              }}
            />
            <span style={{
              fontSize: '16px',
              color: isOnline ? '#00d807ff' : '#4e4d4b',
              fontWeight: 'bold',
              minWidth: '60px'
            }}>
              {isOnline ? "Open" : "Closed"}
            </span>
          </div>
        </div>

        {showAddModal && (
          <div
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '24px',
                borderRadius: '10px',
                width: '360px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                position: 'relative',
                fontFamily: 'Arial, sans-serif',
              }}
            >
              <button
                onClick={() => setShowAddModal(false)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  color: '#000',
                  border: 'none',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                aria-label="Close modal"
              >
                <FaTimes />
              </button>

              <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
                <select
                  value={newTiming.day}
                  onChange={e => handleNewTimingChange('day', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  {getAvailableDays().map(day => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
                {getAvailableDays().length === 0 && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                    All days have been added!
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
                <input
                  type="time"
                  value={newTiming.open}
                  onChange={e => handleNewTimingChange('open', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                  required
                />
                {newTiming.open && (
                  <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
                    Selected: {formatTimeToAMPM(newTiming.open)}
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
                <input
                  type="time"
                  value={newTiming.close}
                  onChange={e => handleNewTimingChange('close', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                  required
                />
                {newTiming.close && (
                  <div style={{ color: '#666', fontSize: '12px', marginTop: '5px' }}>
                    Selected: {formatTimeToAMPM(newTiming.close)}
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Default Status:</label>
                <select
                  value={newTiming.restaurantStatus}
                  onChange={e => handleNewTimingChange('restaurantStatus', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  <option value="Open">Open</option>
                  <option value="Closed">Closed</option>
                </select>
                <div style={{ color: '#666', fontSize: '11px', marginTop: '5px' }}>
                  Note: Status will update automatically based on current time
                </div>
              </div>

              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={handleAddTiming}
                  disabled={getAvailableDays().length === 0 || !newTiming.open || !newTiming.close}
                  style={{
                    padding: '10px 20px',
                    cursor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 'not-allowed' : 'pointer',
                    backgroundColor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? '#cccccc' : 'rgb(177, 92, 214)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '15px',
                    opacity: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 0.6 : 1,
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        <div style={{ height: getTableHeight(), overflowY: "auto" }}>
          {timings.length === 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '300px',
              textAlign: 'center',
              color: '#666',
              fontSize: '18px',
              fontWeight: 'bold',
              background: '#ffffffff',
              borderRadius: '8px',
              padding: '20px',
              border: '0px dashed #ddd'
            }}>
              
              <div>No timings added yet</div>
              <div style={{
                fontSize: '14px',
                color: '#999',
                marginTop: '10px',
                maxWidth: '300px'
              }}>
                Click "Add +" to add your first timing
              </div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
              <thead>
                <tr>
                  <th style={tableHeaderStyle}>S.No</th>
                  <th style={tableHeaderStyle}>Day</th>
                  <th style={tableHeaderStyle}>Open Time</th>
                  <th style={tableHeaderStyle}>Close Time</th>
                  <th style={tableHeaderStyle}>
                    Status
                   
                  </th>
                  <th style={tableHeaderStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {timings.map((item, index) => {
                  const calculatedStatus = calculateStatus(item.day, item.open, item.close, item.restaurantStatus);
                  const isToday = item.day === currentDayName;
                  
                  return (
                    <tr key={item.id || item.day} style={{
                      backgroundColor: isToday ? '#f0f7ff' : 'transparent'
                    }}>
                      <td style={tableCellStyle}>{index + 1}</td>
                      <td style={tableCellStyle}>
                        <div>
                          {item.day}
                         
                        </div>
                      </td>
                      <td style={tableCellStyle}>
                        {item.isEditing ? (
                          <input
                            type="time"
                            value={item.open}
                            onChange={e => handleChange(index, 'open', e.target.value)}
                            style={{ ...inputStyle }}
                          />
                        ) : (
                          formatTimeToAMPM(item.open)
                        )}
                      </td>
                      <td style={tableCellStyle}>
                        {item.isEditing ? (
                          <input
                            type="time"
                            value={item.close}
                            onChange={e => handleChange(index, 'close', e.target.value)}
                            style={inputStyle}
                          />
                        ) : (
                          formatTimeToAMPM(item.close)
                        )}
                      </td>
                      <td style={tableCellStyle}>
                        <div style={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center',
                          gap: '4px'
                        }}>
                          <span style={{
                            color: calculatedStatus.status === 'Open' ? '#4CAF50' : '#f44336',
                            fontWeight: 'bold',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            backgroundColor: calculatedStatus.status === 'Open' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                            minWidth: '80px'
                          }}>
                            {calculatedStatus.status}
                          </span>
                          {calculatedStatus.isDynamic && (
                            <div style={{
                              fontSize: '10px',
                              color: '#666',
                              fontStyle: 'italic',
                              textAlign: 'center'
                            }}>
                              {calculatedStatus.reason}
                            </div>
                          )}
                          {!calculatedStatus.isDynamic && isToday && (
                            <div style={{
                              fontSize: '10px',
                              color: '#666',
                              fontStyle: 'italic',
                              textAlign: 'center'
                            }}>
                              Outside business hours
                            </div>
                          )}
                        </div>
                      </td>
                      <td style={tableCellStyle}>
                        <button
                          type="button"
                          onClick={() => toggleEdit(index)}
                          style={{
                            ...buttonStyle,
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '18px',
                            color: '#4A148C',
                            marginRight: '8px',
                          }}
                          title="Edit Time"
                        >
                          {item.isEditing ? <FaSave /> : <FaEdit />}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </form>
    </div>
  );
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
  padding: "8px",
  whiteSpace: "nowrap",
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  padding: "8px",
};

const inputStyle = {
  width: '100%',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
};

const buttonStyle = {
  backgroundColor: '#dc3545',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginRight: "5px"
};

export default Timings;